import React from 'react';
import MainLogo from '@/assets/logo.svg';
import JXKLogo from '@/assets/jinxiaoke.svg';

function OemLogo() {
  const isJXK = window.location.host.indexOf('fz.jinxiaoke.com') >= 0;
  return isJXK ? /*#__PURE__*/React.createElement(JXKLogo, null) : /*#__PURE__*/React.createElement(MainLogo, null);
}

export default OemLogo;